import { createContext, useContext } from "react";
// 只取类型：import type 在编译期被完全擦除，不会把 useFloatingIcons（连带 12 个
// 活动弹窗 hook、约 160KB）拖进消费方的静态闭包。
// Provider 的实现在 ./FloatingIconsProvider，由 App 以 lazy 加载。
import type { useFloatingIcons } from "../components/Event/hooks/useFloatingIcons";

export type FloatingIconsContextValue = ReturnType<typeof useFloatingIcons>;

export const FloatingIconsContext =
  createContext<FloatingIconsContextValue | null>(null);

export const useFloatingIconsContext = (): FloatingIconsContextValue => {
  const ctx = useContext(FloatingIconsContext);
  if (!ctx) {
    console.warn(
      "[useFloatingIconsContext] used outside FloatingIconsProvider, returning empty fallback"
    );
    return {
      floatingIcons: [],
      leftBottomFloatingIcons: [],
      PopupRegistrationComponent: () => null,
    } as unknown as FloatingIconsContextValue;
  }
  return ctx;
};
